import { usePlatformSettingsStore, selectBranding } from '@/store/platform-settings/store';
import { useThemeStore } from '@/store/theme/store';

export default function Logo() {
  const branding = usePlatformSettingsStore(selectBranding);
  const theme = useThemeStore((state) => state.theme);

  // Determine which logo URL to use based on theme
  const getLogoUrl = (): string | null => {
    if (theme === 'dark') {
      return branding.LOGO_DARK_URL || branding.LOGO_URL || null;
    }
    return branding.LOGO_LIGHT_URL || branding.LOGO_URL || null;
  };

  const logoUrl = getLogoUrl();
  const platformName = branding.PLATFORM_NAME || '';

  // Theme-based logo selection for fallback
  const logoSrc = theme === 'dark'
    ? '/assets/images/logo-full-white.png'
    : '/assets/images/logo-full-black.png';

  // If we have a dynamic logo URL, use it
  if (logoUrl && logoUrl.trim() !== '') {
    return (
      <h1 id="logo">
        <div className="logo-content">
          <img
            src={logoUrl}
            alt={platformName}
            className="logo-dynamic"
            style={{ height: '74px', width: 'auto' }}
          />
          <p
            style={{
              flexShrink: 0,
              width: 'auto',
              height: 'auto',
              whiteSpace: 'pre',
              position: 'relative',
              fontSize: 16,
              letterSpacing: 0,
              lineHeight: 1.2,
              textAlign: 'center',
              margin: 0,
            }}
          >
            {platformName}
          </p>
        </div>
      </h1>
    );
  }

  // Fallback: default logo with theme support (full Davensi wordmark)
  return (
    <h1 id="logo">
      <div className="logo-content">
        <img
          className="logo-desktop"
          src={logoSrc}
          alt="Davensi"
          width={140}
          height={40}
          style={{ objectFit: 'contain', width: 140, height: 'auto' }}
        />
        <img
          className="logo-tablet"
          src={logoSrc}
          alt="Davensi"
          width={110}
          height={32}
          style={{ objectFit: 'contain', width: 110, height: 'auto' }}
        />
      </div>
    </h1>
  );
}
